import Swal from 'sweetalert2'
import { VueConstructor } from 'vue/types/umd'

const TOAST_SUCCESS_MESSAGE = 'Успешно'
const TOAST_ERROR_MESSAGE = 'Ошибка обработки запроса'

const SwalPlugin = {
  install(Vue: VueConstructor) {
    Vue.prototype.$modal = Swal

    const modalConfirmConfig = {
      showCancelButton: true,
      confirmButtonText: 'Подтвердить',
      confirmButtonColor: '#4caf50',
      cancelButtonText: 'Отменить',
      reverseButtons: true,
    }
    Vue.prototype.$modalConfirm = Swal.mixin(modalConfirmConfig)
    Vue.prototype.$modalConfirmDanger = Swal.mixin({
      ...modalConfirmConfig,
      confirmButtonColor: '#dc3545',
    })

    const toastConfig = {
      toast: true,
      position: 'top-end' as 'top-end',
      showConfirmButton: false,
      timer: 3000,
    }
    Vue.prototype.$toast = Swal.mixin(toastConfig)
    Vue.prototype.$toastSuccess = Swal.mixin({
      ...toastConfig,
      icon: 'success',
      title: TOAST_SUCCESS_MESSAGE,
    })
    Vue.prototype.$toastError = Swal.mixin({
      ...toastConfig,
      icon: 'error',
      title: TOAST_ERROR_MESSAGE,
    })
    Vue.prototype.$toastWarning = Swal.mixin({
      ...toastConfig,
      icon: 'warning',
      title: TOAST_ERROR_MESSAGE,
    })
  },
}

export { SwalPlugin, TOAST_ERROR_MESSAGE, TOAST_SUCCESS_MESSAGE }
